module.exports = __webpack_public_path__ + "media/ComputerKeyboard3174.0a65f171.mp4";